import { CompanyMarketView, MarketView } from '@api-proxies';
import { MarketService } from '@http/clients/market.service';
import { MarketEntity } from './abstract/market-entity';

export class CompanyMarketEntity extends MarketEntity<CompanyMarketView> {
    constructor(marketService: MarketService) {
        super(marketService);
    }

    toDestination(entity: MarketView): CompanyMarketView {
        return { marketId: entity.id, marketName: entity.name, companyId: 0, id: 0, companyName: undefined };
    }

    toSource(entity: CompanyMarketView): MarketView {
        return { id: entity.marketId, name: entity.marketName };
    }
}
